import { AdminState } from './admin-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, StateStatus } from '../reducers/utils/state-manager';

const InitialState: AdminState = {
  twilioRegistrationSummary: {
    missingInformationAccounts: [],
    failedBundleRegistrations: [],
    failedCampaignRegistrations: [],
    inProgressBundleRegistrations: [],
    inProgressCampaignRegistrations: [],
    campaignRegistrationSummary: [],
  },
  twilioRegistrationSummaryStatus: StateStatus.notAttempted,
};

export const adminReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_TWILIO_REGISTRATION_SUMMARY'): {
      state.twilioRegistrationSummaryStatus = StateStatus.loading;
      return state;
    }
    case SUCCESS('LOAD_TWILIO_REGISTRATION_SUMMARY'): {
      const { data } = action.payload;
      state.twilioRegistrationSummary = data;
      state.twilioRegistrationSummaryStatus = StateStatus.success;
      return state;
    }
    case FAILURE('LOAD_TWILIO_REGISTRATION_SUMMARY'): {
      state.twilioRegistrationSummaryStatus = StateStatus.error;
      return state;
    }
    default:
      return state;
  }
};
